module.exports = __webpack_public_path__ + "img/pin_newWaypoint.1695ab0.png";